import { IModalAction } from 'models/modal';
import { IOnboardingQuiz, IOnboardingQuizAction, IOnboardingQuizFormData } from 'models/onboardingquiz';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import React = require('react');
import { BasicButton, Button, EllipseGreyBlackButton } from 'components/Common/Button';
import { WizardSideNav } from 'components/WizzardSideNav';
import { reduxForm, getFormSyncErrors, Field, change } from 'redux-form';
import { WizzardSteps } from 'components';
import { connect } from 'react-redux';
import { IStore } from 'redux/IStore';
import { IDomainValue } from 'models/common';
import { IDomainValuesAction } from 'models/domainvalues/domainvalues';
import { getHairProductsDomainValues, getScalpMoistureDomainValues } from 'redux/modules/domainvalues';
import { PortalTileSelector } from 'components/FormControls/PortalTileSelector';

interface IProps {
	currentFormValues: IOnboardingQuizFormData;
	initialValues: IOnboardingQuizFormData;
	onboardingQuiz?: IOnboardingQuiz;
	dispatch?: any;
	editMode?: boolean;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	formErrors?: any;
	scalpMoistureDomainValues: IDomainValue[];
	hairProductsDomainValues: IDomainValue[];
	steps?: string[];

	/* functions props */
	t?: (key: string, options?: any) => string;
	onSubmit?: (form: IOnboardingQuizFormData) => IOnboardingQuizAction;
	closeModal?: () => IModalAction;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	change: (field: string, value: any) => void;
	previousPage?: () => IOnboardingQuizAction;
	getScalpMoistureDomainValues?: () => IDomainValuesAction;
	getHairProductsDomainValues?: () => IDomainValuesAction;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ScalpConditionForm extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
	}

	private onSubmit(form: IOnboardingQuizFormData) {
		this.props.onSubmit(form);
	}

	public componentDidMount() {
		this.props.getScalpMoistureDomainValues();
		this.props.getHairProductsDomainValues();
	}

	public render() {
		const { handleSubmit, t, scalpMoistureDomainValues, hairProductsDomainValues, steps, editMode } = this.props;

		const scalpMoistures = [];
		if (scalpMoistureDomainValues) {
			scalpMoistureDomainValues.forEach((type: IDomainValue) => {
				scalpMoistures.push({
					key: type.key,
					value: t(`DV_ScalpMoisture_${type.key}`),
				});
			});
		}

		const hairProducts = [];
		if (hairProductsDomainValues) {
			hairProductsDomainValues.forEach((type: IDomainValue) => {
				hairProducts.push({
					key: type.key,
					value: t(`DV_HairProduct_${type.key}`),
				});
			});
		}

		const wizardPagination = (
			<div className="wizardBottomNav withButton">
				{editMode ? (
					<Button type="submit" size="small">
						{t('OnboardingQuiz_Complete')}
					</Button>
				) : (
					<div className="wizardPagination">
						<BasicButton type="button" onClick={this.props.previousPage}>
							<img style={{ transform: 'rotate(180deg)' }} src={require('../../Html/icons/arrow-black.svg')} />
						</BasicButton>
						<WizzardSteps currentStep={4} numberOfSteps={8} />
						<BasicButton type="submit">
							<img src={require('../../Html/icons/arrow-black.svg')} />
						</BasicButton>
					</div>
				)}
			</div>
		);

		return (
			<div className="quizScalpCondition">
				<div className="modalBodyHeader">
					{steps ? <WizardSideNav steps={steps} active={1} /> : null}
					<h1 dangerouslySetInnerHTML={{ __html: t('OnboardingQuiz_ScalpCondition_Title') }}></h1>
					{steps ? (
						<EllipseGreyBlackButton onClick={this.onSubmit}>{t('OnboardingQuiz_Skip')}</EllipseGreyBlackButton>
					) : null}
				</div>
				<div className="modalBodyContent">
					{steps ? <WizardSideNav steps={steps} active={1} /> : null}
					<div className="wizardContent">
						<form onSubmit={handleSubmit(this.onSubmit)}>
							<div>
								<Field
									name="scalpMoisture"
									component={PortalTileSelector}
									items={scalpMoistures}
									multi={false}
									withImages={false}
									type="select"
								/>
								<h1 dangerouslySetInnerHTML={{ __html: t('OnboardingQuiz_HairCareProducts_Title') }}></h1>
								<Field
									name="hairProducts"
									component={PortalTileSelector}
									items={hairProducts}
									multi={true}
									withImages={false}
									type="select"
								/>
							</div>
							{wizardPagination}
						</form>
					</div>
				</div>
			</div>
		);
	}
}

let ScalpCondition = reduxForm({
	form: c.FORM_NAME_ONBOARDING_QUIZ,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
})(ScalpConditionForm);

ScalpCondition = connect(
	(state: IStore) => {
		let currentFormValues: IOnboardingQuizFormData = null;
		if (state.form[c.FORM_NAME_ONBOARDING_QUIZ] && state.form[c.FORM_NAME_ONBOARDING_QUIZ].values) {
			currentFormValues = state.form[c.FORM_NAME_ONBOARDING_QUIZ].values;
		} else {
			currentFormValues = state.onboardingQuiz.formData;
		}

		return {
			initialValues: state.onboardingQuiz.formData,
			onboardingQuiz: state.onboardingQuiz,
			currentFormValues,
			scalpMoistureDomainValues: state.domainValues.scalpMoisture,
			hairProductsDomainValues: state.domainValues.hairProducts,
			formErrors: getFormSyncErrors(c.FORM_NAME_ONBOARDING_QUIZ)(state),
		};
	},
	(dispatch) => ({
		change: (field: string, value: string) => dispatch(change(field, value)),
		getScalpMoistureDomainValues: () => dispatch(getScalpMoistureDomainValues()),
		getHairProductsDomainValues: () => dispatch(getHairProductsDomainValues()),
	}),
)(ScalpCondition);

export { ScalpCondition };
